export default __webpack_public_path__ + "static/media/IMG_1791.8af2d9f7.JPG";